// Transaction Transactions State

export default {
  transactionsList: [],
  transactionInfo: {}
}
